import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./ConsultationSection.module.css";
import imagen from "../../assets/13.jpg";

function ConsultationSection() {
  const navigate = useNavigate();
  const sectionRef = useRef(null);
  
  useEffect(() => {
    const sectionElement = sectionRef.current;
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        // Cuando la sección entra en el viewport
        if (entry.isIntersecting) {
          sectionElement.classList.add(styles.visible);
          observer.unobserve(entry.target); // Dejar de observar después de activar
        }
      });
    }, { threshold: 0.2 }); // Activar cuando al menos 20% de la sección sea visible
    
    if (sectionElement) {
      observer.observe(sectionElement);
    }
    
    return () => {
      if (sectionElement) {
        observer.unobserve(sectionElement);
      }
    };
  }, []);

  const treatments = [
    {
      title: "Toxina Botulínica",
      description:
        "Un tratamiento no quirúrgico eficaz para atenuar arrugas dinámicas y controlar la hiperhidrosis, relajando los músculos y previniendo la formación de líneas de expresión.",
      path: "/servicios/toxina-botulinica",
    },
    {
      title: "Ácido Hialurónico Ultrapuro",
      description:
        "Un protocolo antiaging que combina ácido hialurónico de alto y bajo peso molecular en alta concentración (64 mg) para la bioremodelación cutánea, ideal para rejuvenecimiento facial, cervical y escote.",
      path: "/servicios/acido-hialuronico",
    },
    {
      title: "Mesocapilar",
      description:
        "Un protocolo avanzado de bioestimulación capilar diseñado para fortalecer los folículos pilosos, reactivar el crecimiento del cabello y recuperar la densidad capilar en casos de alopecia.",
      path: "/servicios/mesocapilar",
    },
    {
      title: "Limpieza Facial Profesional",
      description:
        "Un protocolo dermatológico que elimina impurezas, restaura el equilibrio cutáneo y potencia la luminosidad natural de la piel, ofreciendo una detoxificación y renovación epidérmica completa.",
      path: "/servicios/limpieza",
    },
  ];

  const handleButtonClick = (path) => {
    navigate(path);
  };

  return (
    <section className={styles.consultationsection} ref={sectionRef}>
      <div className={styles.sectionheader}>
        <h3>DRA. GLADYS QUINTERO MÉDICA ESTÉTICA</h3>
        <h2>Conoce algunos de nuestros</h2>
        <h2 className={styles.highlight}>tratamientos destacados.</h2>
      </div>

      <div className={styles.contentwrapper}>
        <div className={styles.treatmentscontainer}>
          {treatments.map((treatment, index) => (
            <div key={index} className={styles.treatmentcard}>
              <h3>{treatment.title}</h3>
              <p>{treatment.description}</p>
              <button
                className={styles.arrowbutton}
                onClick={() => handleButtonClick(treatment.path)}
              >
                <span>→</span>
              </button>
            </div>
          ))}
        </div>

        <div className={styles.imagecontainer}>
          <img
            src={imagen}
            alt="Procedimiento dermatológico"
            className={styles.circularimage}
          />
        </div>
      </div>
    </section>
  );
}

export default ConsultationSection;